import React, { lazy } from 'react';

const PosLoginPage = lazy(() => import('./PosLoginPage'));
const PosLoginFailedPage = lazy(() => import('./PosLoginFailed'));

const PosAppConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/posLogin',
			element: <PosLoginPage />
		},
		{
			path: '/posLoginFailed',
			element: <PosLoginFailedPage />
		}
	]
};

export default PosAppConfig;
